module.exports = __webpack_public_path__ + "56b8bf8100c860b209b5b90c8aaf4056.png";